module.exports = new __parcel__URL__("reward_cancel_button.31c9bd41.png").toString();